import React from "react";
import { IconCheck, IconPlus } from "@tabler/icons-react";
const cn = (...classes) => classes.filter(Boolean).join(" ");

export let plan = (function (plan) {
  plan["Weekly"] = "Weekly";
  plan["Monthly"] = "Monthly";
  plan["Quarterly"] = "Quarterly";
  return plan;
})({});

const plans = [
  {
    id: plan.hobby,
    name: "Weekly",
    price: 60,
    subText: "/week",
    currency: "£",
    features: ["One online session", "Using microsoft teams"],
    buttonText: "Book one session",
    onClick: () => {
      console.log("Book one session");
    }
  },
  {
    id: plan.starter,
    name: "Monthly",
    price: 200,
    subText: "/month",
    currency: "£",
    featured: false,
    features: ["Four sessions a month", "Using microsoft team "],
    buttonText: "Book monthly sessions",
    additionalFeatures: ["Everything in Hobby Plan"],
    onClick: () => {
      console.log("Book monthly sessions");
    }
  },
  {
    id: plan.pro,
    name: "Quarterly",
    price: 500,
    subText: "/quarter",
    currency: "£",
    features: [
      "Twelve sessions in a three month period",
      "Microsoft teams link"
    ],
    additionalFeatures: [
      "Everything in Hobby Plan",
      "Everything in Starter Plan"
    ],
    buttonText: "Book quarterly sessions",
    onClick: () => {
      console.log("Get Pro");
    }
  }
];

function SimplePricingWithThreeTiers() {
  return (
    <div className="relative isolate bg-transparent px-4 py-0 sm:py-10 lg:px-4 max-w-7xl mx-auto">
      <h2 className="pt-4 font-bold text-lg md:text-4xl text-center text-blue-900 dark:text-neutral-100">
        Packages
      </h2>
      <p className="max-w-md mx-auto text-base text-center text-blue-900 dark:text-neutral-300 mt-4">
        Please if you are a new client before you book a package contact me.
      </p>
      <div
        className={cn(
          "mx-auto grid grid-cols-1 gap-4 mt-20 md:grid-cols-2 xl:grid-cols-3"
        )}
      >
        {plans.map((tier, tierIdx) => (
          <Card plan={tier} key={tier.id} onClick={tier.onClick} />
        ))}
      </div>
    </div>
  );
}

const Card = ({ plan, onClick }) => {
  return (
    <div
      className={cn(
        "p-1 sm:p-4 md:p-4 rounded-3xl bg-gray-50 dark:bg-neutral-900 border border-gray-100 dark:border-neutral-800"
      )}
    >
      <div className="flex flex-col gap-4 h-full justify-start">
        <div
          className={cn(
            "p-4 bg-white dark:bg-neutral-800 rounded-2xl shadow-input w-full"
          )}
        >
          <div className="flex justify-between items-start">
            <p className={cn("font-medium text-lg text-black dark:text-white")}>
              {plan.name}
            </p>
            {plan.featured && (
              <span
                className={cn(
                  "font-medium text-xs px-3 py-1 rounded-full bg-blue-900 dark:bg-white dark:text-black text-white"
                )}
              >
                Featured
              </span>
            )}
          </div>
          <div className="mt-8 flex items-end">
            <span
              className={cn(
                "text-lg font-bold text-blue-900 dark:text-neutral-200"
              )}
            >
              {plan.currency}
            </span>
            <span
              className={cn(
                "text-3xl md:text-7xl font-bold dark:text-blue-900 text-blue-900"
              )}
            >
              {plan.price}
            </span>
            <span
              className={cn(
                "text-base font-normal text-blue-900 dark:text-neutral-200 mb-1 md:mb-2"
              )}
            >
              {plan.subText}
            </span>
          </div>
          <button
            className={cn(
              "w-full mt-10 mb-4 px-2 py-2 rounded-lg bg-gradient-to-b from-sky-500 to-sky-600 text-white font-medium"
            )}
            onClick={onClick}
          >
            {plan.buttonText}
          </button>
        </div>
        <div className="mt-1 p-4">
          {plan.features.map((feature, idx) => (
            <Step key={idx}>{feature}</Step>
          ))}
          {plan.additionalFeatures && (
            <Divider>
              {plan.additionalFeatures.map((feature, idx) => (
                <Step key={idx} additional>
                  {feature}
                </Step>
              ))}
            </Divider>
          )}
        </div>
      </div>
    </div>
  );
};

const Step = ({ children, additional }) => {
  return (
    <div className="flex items-start justify-start gap-2 my-4">
      <div
        className={cn(
          "h-4 w-4 rounded-full flex items-center justify-center mt-0.5",
          additional ? "bg-sky-500" : "bg-neutral-700"
        )}
      >
        <IconCheck className="h-3 w-3 text-neutral-300" />
      </div>
      <div className={cn("font-medium text-sm text-black dark:text-white")}>
        {children}
      </div>
    </div>
  );
};

const Divider = () => {
  return (
    <div className="relative">
      <div className="w-full h-px bg-blue-900 dark:bg-neutral-800" />
      <IconPlus className="h-3 w-3 absolute inset-0 m-auto text-black dark:text-neutral-300" />
    </div>
  );
};

export default SimplePricingWithThreeTiers;
